import React, { useState } from 'react'

export const ModalContext = React.createContext({ domNode: null })

export default function ModalWrapper({ children }) {
  const [domNode, setDomNode] = useState(null)

  return (
    <ModalContext.Provider value={{ domNode }}>
      <div ref={(ref) => setDomNode(ref)}>{domNode ? children : null}</div>
    </ModalContext.Provider>
  )
}
